import { UserMessagesService } from 'src/app/angularJS/services/user-messages.service';

export class ErrorDialogController {
  public static $inject = ['$mdDialog', '$injector', 'response'];
  public title: string;
  public message: string;

  constructor(
    private $mdDialog: ng.material.IDialogService,
    private $injector: ng.auto.IInjectorService,
    response) {
    this.title = response.errorTitle;
    this.message = response.errorMessage;
  }

  public ok = () => {
    (<UserMessagesService>this.$injector.get('UserMessages')).errorDialogVisible = false;
    this.$mdDialog.cancel();
  }
}